namespace Solovis.Reports.Layouts {

    export interface LayoutPartOptions {
        reportControl: any,
        partDefinition: any,
        parentLayoutPart?: any
        renderMode: Solovis.UI.BaseControlOptions['renderMode']
    }

    export class LayoutPart {

        public reportControl;
        public partDefinition;
        public parentLayoutPart;
        public parameters;
        public dataSets;
        public _parentVisible;
        public _currentlyVisible;
        public _visibilityTestResult;
        public childPartList;
        public options:LayoutPartOptions

        public layoutDiv;

        constructor(options:LayoutPartOptions) {
            this.reportControl = options.reportControl;
            this.partDefinition = options.partDefinition;
            this.parentLayoutPart = options.parentLayoutPart ? options.parentLayoutPart : null;
            this.options = options;

            this.parameters = null;
            this.dataSets = null;

            this._parentVisible = false;
            this._currentlyVisible = false;
            this._visibilityTestResult = true;

            if (!this.parentLayoutPart) {
                // Root layout part is assumed to be visibile.
                this._parentVisible = true;
            }

            this.childPartList = [];
        }




        public updateParameters(newParameters) {
            this.parameters = newParameters;

            this._runVisibilityTest();
            this._updateVisibility();
        };

        public updateDataSets(dataSets) {
            this.dataSets = dataSets;

            this._runVisibilityTest();
            this._updateVisibility();
        };

        public _runVisibilityTest() {
            // By default, we assume we can be visible, but if the partDefinition specifies a visible check, we should use that.
            if (this.partDefinition.visible) {
                this._visibilityTestResult = this.partDefinition.visible.call(this);
            }
        };

        public _updateVisibility() {
            var self = this;

            var shouldBeVisible = this._parentVisible && this._visibilityTestResult;

            if (this._currentlyVisible != shouldBeVisible) {
                this._currentlyVisible = shouldBeVisible;

                if (shouldBeVisible) {
                    if (this.layoutDiv) {
                        if (this.partDefinition && this.partDefinition.style && this.partDefinition.style.display) {
                            this.layoutDiv.css("display", this.partDefinition.style.display)
                        } else {
                            this.layoutDiv.css("display", "block");
                        }                        
                    }
                }
                else {
                    if (this.layoutDiv) {
                        this.layoutDiv.css("display", "none");
                    }
                }
            }

            // We refactor this into a separate function, so it can be overridden by layout parts like BlockWithHeader.
            self._updateAllChildPartsVisibility();
        };

        public _updateAllChildPartsVisibility() {
            var self = this;

            $(this.childPartList).each(function (i, childPart) {
                self._updateChildPartParentVisibility(childPart, self._currentlyVisible);
            });
        };

        public _updateChildPartParentVisibility(childPart, isVisible) {
            if (childPart.layoutPart) {
                childPart.layoutPart.updateParentVisibility(isVisible);
            }
            else if (childPart.partControlHost) {
                if (childPart.partControlHost.currentControl) {
                    var partControl = childPart.partControlHost.currentControl;

                    if (partControl.updateParentVisibility) {
                        partControl.updateParentVisibility(isVisible);
                    }
                }
            }
        };

        public updateParentVisibility = function (parentVisible) {
            // This will be called by parent part when visibility changes.
            this._parentVisible = parentVisible;
            this._updateVisibility();
        };


        public collectSettingsForLayoutPart = function (collectSettingsForPartMethod) {
            $(this.childPartList).each(function (i, childPart) {
                collectSettingsForPartMethod(childPart);
            });
        };

    }

}
